<template>

          <v-row justify="center" align="center" class="ma-0 pa-0 bottom-logo-off"  >
            <v-col cols="7">
              <v-row justify="space-around" align="end" class="ma-0 pa-0">
                <v-col cols="2" class="cursor-url" :key="`klb-`+klb" v-for=" (itmLB, klb) in dataAdmin.anchor_logos" >
                  <v-img :src="itmLB.anchor_logo" @click="goToPage(itmLB.slug)">
                  </v-img>        
                </v-col>
              </v-row>
            </v-col>
          </v-row>

</template>
<script>
import Vue from 'vue'
import Vuex from 'vuex'
import router from 'vue-router'

Vue.use(Vuex)

export default {
  name: 'BottomLogo',

  data () {
    return {

      arrLogoBottom: [
        "94",
        "233",
        "166",
        "117",
      ],
    }
  },
  computed:{
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    
    dataAdmin:{
      get () {
        return this.$store.getters.getDataAdmin;
      },
     
    },
    loadPathData: {
          get () {
            return this.$store.getters.getLoadPathData
          }          
        },    
    darkTheme: {
      get () {
        return this.$store.state.app.darkTheme
      },
      set (value) {
        this.$store.dispatch('setTheme', value)
      },

    },
     shops: {
      get () {
        return this.$store.state.shops.shops
      },

     },
     },

  methods: {
    getLogoUrl(idSH){
      let vApp = this;
      if(DEBUG) console.log('idSH :', idSH);
      if(DEBUG) console.log('vApp.shops :', vApp.shops);
      return vApp.shops.find(shpl => shpl.id === idSH).logourl;
    },
    goToPage (url) {
      let vApp = this;
      if(DEBUG) console.log('id url :', url);
      if(DEBUG) console.log('id path :', vApp.$route.name);

      vApp.$router.push('/'+vApp.loadPathData.mnuShopsPath+'/'+url);
    },
     },
     
     mounted(){
    let vApp = this;
    this.$nextTick(function () {      
      if(DEBUG) console.log('this.$store TopFullMenu :', vApp.$store)


                if(DEBUG) console.log('logourl :', vApp.shops);
            })
            }
}
</script>


<style scoped>


.bottom-logo{
  width: 100%;
  position: absolute;
  top: 10px;


}
</style>